import React, { FC, useCallback, useState, useRef } from 'react';
import { CategoryProps, Chat } from './chat';
import { Message } from '../../components/chat/types';
import { getIAResposta, getConversationId } from '../../apis/ia';
import { cancelarVoz } from '../../util/voice';
import { useSharedChat } from '../../components/chat/hooks/useSharedChat';
import { MESSAGE_TYPES } from './constants';
import { handleAudioResponse, createLiaMessage, createErrorMessage } from './utils';
import { useWebgate } from '@xvia/webgate-connect';

export const ChatContainer: FC = () => {
  const conversationIdRef = useRef<string | null | undefined>(null);
  const validConversationIdRef = useRef<boolean>(false);

  const { messages, setMessages, input, setInput } = useSharedChat();
  const [loading, setLoading] = useState<boolean>(false);
  const userInfoInjected = useRef(false);

  const { userInfo } = useWebgate();

  const processUserMessage = useCallback(async (message: Message) => {
    cancelarVoz();

    if (message.from === MESSAGE_TYPES.USER) {
      setLoading(true);
    }

    let messageText = typeof message.text === 'string' ? message.text : '';

    try {
      setMessages(prev => [...prev, message]);

      if (userInfo) {
        messageText = `Pergunta do usário: `+messageText
        messageText += ` \\n\\n ### Informações Vindas do usuário logado - começo \\n ${JSON.stringify(userInfo)} \\n ### Informações Vindas do usuário logado - fim`;
        userInfoInjected.current = true;
      } else if (!userInfo && userInfoInjected.current) {
        userInfoInjected.current = false;
        conversationIdRef.current = null;

        localStorage.removeItem('conversationId');
      }

      if (!conversationIdRef.current && !validConversationIdRef.current) {
        const newConversationId = await getConversationId();
        conversationIdRef.current = newConversationId || null;
        validConversationIdRef.current = true;
      }

      const response = await getIAResposta(messageText, conversationIdRef.current);

      if (message.type === MESSAGE_TYPES.AUDIO) {
        handleAudioResponse(response.toString());
      }

      const liaMessage = createLiaMessage(response.toString());
      setMessages(prev => [...prev, liaMessage]);
    } catch (error) {
      console.error('Erro ao obter resposta da IA:', error);
      const errorMessage = createErrorMessage();
      setMessages(prev => [...prev, errorMessage]);
    } finally {
      setLoading(false);
    }
  }, [setMessages, userInfo]);

  const props: CategoryProps = {
    messages,
    input,
    setInput,
    setMessages: processUserMessage,
    loading,
    conversationId: conversationIdRef.current || undefined,
  };

  return <Chat {...props} />;
};
